<div *ngIf="!isLoading; else loading" class="container">
  <div class="title">Listes des {{ profileListName | lowercase }} concernés</div>
  <div *ngIf="formGroup" class="body" fxLayout="column" fxLayoutAlign="start stretch">
    <div class="first-column">
      <div class="mg-b-12">
        <app-text-input [(inputModel)]="cycleName" ngDefaultControl label="Nom du roulement"></app-text-input>
      </div>
      <div class="input-label mg-t-12">Type de soignant</div>

      <div class="profiles-options-container">
        <div *ngFor="let option of profileListOptions" fxLayoutAlign="space-between center" [style.gap]="gap">
          <button
            class="mat-flat-button"
            mat-flat-button
            [class.checked]="profileListNames.includes(option)"
            [disabled]="isOptionDisabled(option)"
          >
            {{ option }}
          </button>
        </div>
      </div>

      <div *ngIf="isUsingSeniorities">
        <div class="input-label mg-t-12">Séniorité</div>
        <div class="profiles-options-container">
          <div *ngFor="let option of profilesSeniorities" fxLayoutAlign="space-between center" [style.gap]="gap">
            <button
              class="mat-flat-button"
              mat-flat-button
              (click)="getProfileListType(option)"
              [class.checked]="selectedProfilesSeniorities.includes(option)"
            >
              {{ option }}
            </button>
          </div>
        </div>
      </div>

      <div class="input-label mg-t-12">Statut</div>
      <div class="profiles-options-container">
        <div *ngFor="let option of profilesStatus" fxLayoutAlign="space-between center" [style.gap]="gap">
          <button
            class="mat-flat-button"
            mat-flat-button
            (click)="getProfileListType(option)"
            [class.checked]="selectedProfilesStatus.includes(option)"
          >
            {{ option }}
          </button>
        </div>
      </div>
    </div>
    <div class="second-column">
      <app-text-input
        class="search-input"
        label="Rechercher une personne"
        placeholder="Rechercher une personne ..."
        icon="search"
        iconType="mat-icon"
        [(inputModel)]="searchValue"
        ngDefaultControl
        (keyup)="doFilter($any($event.target).value)"
      ></app-text-input>

      <div class="profiles-box">
        <div *ngFor="let profile of profilesFormElements; let i = index" class="profile-box">
          <mat-checkbox [checked]="isProfileSelected(profile.value)" (change)="onProfileChange($event, profile.value)">
            {{ profile.label }}
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>

  <div class="buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-button (click)="close()" text="Annuler" btnType="text"></app-button>
    <app-button
      (click)="save()"
      btnType="primary"
      color="primary"
      text="Mettre à jour la liste"
      [disabled]="getSelectedIDS(allProfiles ?? []).length === 0"
    ></app-button>
  </div>
</div>

<ng-template #loading>
  <div class="spinnerContainer" fxLayoutAlign="center center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
